module.exports = __webpack_public_path__ + "assets/DeliveryFeeGift-6d6831.svg";